// components/loginforms/PasswordValidation.js
import { useState, useEffect } from 'react';
import styles from '../Header.module.css';

const PasswordValidation = ({ password, setPassword }) => {
  const [strength, setStrength] = useState(0);
  const [requirements, setRequirements] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    special: false
  });

  useEffect(() => {
    checkStrength(password);
  }, [password]);

  const checkStrength = (pass) => {
    const newReqs = {
      length: pass.length >= 8,
      uppercase: /[A-Z]/.test(pass),
      lowercase: /[a-z]/.test(pass),
      number: /[0-9]/.test(pass),
      special: /[^A-Za-z0-9]/.test(pass)
    };
    setRequirements(newReqs);
    setStrength(Object.values(newReqs).filter(Boolean).length);
  };

  return (
    <div className={styles.passwordValidation}>
      <div className={styles.strengthMeter}>
        {[...Array(5)].map((_, i) => (
          <div 
            key={i} 
            className={`${styles.strengthBar} ${i < strength ? styles.filled : ''}`}
          />
        ))}
      </div>
      <ul className={styles.requirements}>
        <li className={requirements.length ? styles.met : ''}>8+ characters</li>
        <li className={requirements.uppercase ? styles.met : ''}>uppercase letter</li>
        <li className={requirements.lowercase ? styles.met : ''}>lowercase letter</li>
        <li className={requirements.number ? styles.met : ''}>number</li>
        <li className={requirements.special ? styles.met : ''}>special character</li>
      </ul>
    </div>
  );
};

export default PasswordValidation;